import Vue from 'vue';
import Vuex from 'vuex';
import AuthModule from '@/store/modules/auth.module';
import UiModule from '@/store/modules/ui.module';
import CatalogModule from '@/store/modules/catalog.module';
import ClientsModule from '@/store/modules/clients.module';
import ShoppingModule from '@/store/modules/shopping.module';
import LooksModule from '@/store/modules/looks.module';
import SandboxLooksModule from '@/store/modules/sandboxLooks.module';
import ThingsModule from '@/store/modules/things.module';
import SubscriptionModule from '@/store/modules/subscription.module';
import RolesModule from '@/store/modules/roles.module';
import UsersModule from '@/store/modules/users.module';
import SupplierModule from '@/store/modules/supplier.module';
import SandboxModule from '@/store/modules/sandbox.module';
import CompilationsModule from '@/store/modules/compilationsModule.module';
import { getModule } from 'vuex-module-decorators';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    AuthModule,
    UiModule,
    CatalogModule,
    ClientsModule,
    ShoppingModule,
    LooksModule,
    SandboxLooksModule,
    ThingsModule,
    SubscriptionModule,
    RolesModule,
    UsersModule,
    SupplierModule,
    SandboxModule,
    CompilationsModule,
  },
});

export const authModule = getModule(AuthModule, store);
export const uiModule = getModule(UiModule, store);
export const catalogModule = getModule(CatalogModule, store);
export const clientsModule = getModule(ClientsModule, store);
export const shoppingModule = getModule(ShoppingModule, store);
export const looksModule = getModule(LooksModule, store);
export const sandboxLooksModule = getModule(SandboxLooksModule, store);
export const thingsModule = getModule(ThingsModule, store);
export const subscriptionModule = getModule(SubscriptionModule, store);
export const rolesModule = getModule(RolesModule, store);
export const usersModule = getModule(UsersModule, store);
export const supplierModule = getModule(SupplierModule, store);
export const sandboxModule = getModule(SandboxModule, store);
export const compilationsModule = getModule(CompilationsModule, store);

export default store;
